(function () {
  'use strict';
  if (window.__mlcHeroCarouselBootstrapped) return;
  window.__mlcHeroCarouselBootstrapped = true;

  var instances = new WeakMap();
  var delay = 5000;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(gallery) {
    if (instances.has(gallery)) return;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-mlc-hero-slide]'));
    if (slides.length < 2) return;

    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-mlc-hero-dot]'));
    var pause = gallery.querySelector('[data-mlc-hero-pause]');
    var prev = gallery.querySelector('[data-mlc-hero-prev]');
    var next = gallery.querySelector('[data-mlc-hero-next]');
    var index = 0;
    var timer = null;
    var userPaused = false;
    var pointerOver = false;
    var focusWithin = false;

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }
    function show(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var current = i === index;
        slide.classList.toggle('is-active', current);
        slide.setAttribute('aria-hidden', current ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var current = i === index;
        dot.classList.toggle('is-active', current);
        dot.setAttribute('aria-current', current ? 'true' : 'false');
      });
    }
    function start() {
      stop();
      if (userPaused || pointerOver || focusWithin || document.hidden || reducedMotion.matches) return;
      timer = window.setInterval(function () { show(index + 1); }, delay);
    }
    function syncPause() {
      if (!pause) return;
      pause.textContent = userPaused ? 'Reanudar' : 'Pausar';
      pause.setAttribute('aria-label', userPaused ? 'Reanudar carrusel' : 'Pausar carrusel');
      pause.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); start(); });
    });
    if (pause) pause.addEventListener('click', function () {
      userPaused = !userPaused;
      syncPause();
      start();
    });
    gallery.addEventListener('pointerenter', function () { pointerOver = true; stop(); });
    gallery.addEventListener('pointerleave', function () { pointerOver = false; start(); });
    gallery.addEventListener('focusin', function () { focusWithin = true; stop(); });
    gallery.addEventListener('focusout', function () {
      window.requestAnimationFrame(function () {
        if (!gallery.contains(document.activeElement)) {
          focusWithin = false;
          start();
        }
      });
    });
    function onVisibility() { start(); }
    function onMotionPreference() { start(); }
    document.addEventListener('visibilitychange', onVisibility);
    reducedMotion.addEventListener('change', onMotionPreference);
    instances.set(gallery, function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      reducedMotion.removeEventListener('change', onMotionPreference);
    });
    show(0);
    syncPause();
    start();
  }

  function findGalleries(root) {
    if (!root || !root.querySelectorAll) return [];
    var found = Array.prototype.slice.call(root.querySelectorAll('[data-mlc-hero-gallery]'));
    if (root.matches && root.matches('[data-mlc-hero-gallery]')) found.unshift(root);
    return found;
  }
  function initialize(root) { findGalleries(root).forEach(mount); }
  function unmount(root) {
    findGalleries(root).forEach(function (gallery) {
      var destroy = instances.get(gallery);
      if (destroy) { destroy(); instances.delete(gallery); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
}());